import React from "react";

export default function NoDataFound() {
  return (
    <img
      src="/images/no-data-placeholder.webp"
      alt="No data found"
      className="max-w-300 img-fluid d-flex mx-auto my-5"
    />
  );
}
